import type { Component } from 'vue'
import type { Router } from 'vue-router'
import { createApp } from 'vue'
import { VueQueryPlugin } from 'vue-query'
import { useTheme } from '@/composables/useTheme'
import { i18n } from '@/i18n'
import AuthService from '@/services/auth.service'
import { setHTTPHeader } from '@/services/http.service'
import { pinia } from '@/stores'
import { useMetaStore } from '@/stores/meta.store'
import { globalProperties } from './globalProperties'

const token = AuthService.getToken()
if (token !== null && token !== '') {
  setHTTPHeader({ Authorization: token })
}

export function setupEntryPoint(rootComponent: Component, router: Router) {
  const app = createApp(rootComponent)
  app.use(router)
  app.use(pinia)
  app.use(i18n)
  app.use(VueQueryPlugin)
  app.config.globalProperties = {
    ...app.config.globalProperties,
    ...globalProperties,
  }

  // Inicializar el tema antes de montar la aplicación
  const { initializeTheme } = useTheme()
  initializeTheme()

  // La preferencia persistida se aplica antes del primer render para evitar
  // que al navegar o recargar otras secciones vuelva temporalmente a Geist.
  useMetaStore(pinia).initializeGoogleFont()

  app.mount('#app')
}
